import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Department } from './department';


@JsonObject('DepartmentSearchResults')
export class DepartmentSearchResults extends SearchResults {
    @JsonProperty('results', [Department])
    results: Department[] = [];
}
